import { Alert, Box, Button, FormField, Input, InputProps, Modal, ModalProps, NonCancelableCustomEvent, SpaceBetween } from '@amzn/awsui-components-react';
import { FunctionComponent, useState } from 'react';

import { constants } from '../../common/Localization';
import { format } from '../../common/util';

interface Props {
    header: string;
    warning?: string;
    friction?: string;
    onConfirm: (() => Promise<void>) | (() => void);
    confirmButton?: string;
    confirmLoading?: boolean;
    confirmDisabled?: boolean;
    onSecondaryConfirm?: (() => Promise<void>) | (() => void);
    secondaryButton?: string;
    onDismiss: () => void;
    onCancel?: () => void; // onCancel can be optional when onDismiss is given
    visible: boolean;
    size?: ModalProps.Size;
}

const ConfirmationModal: FunctionComponent<Props> = function(props) {
    const [frictionInput, setFrictionInput] = useState('');
    const [errorText, setErrorText] = useState('');
    function onFrictionChange(event: NonCancelableCustomEvent<InputProps>) {
        setFrictionInput(event.detail.value);
        setErrorText(event.detail.value === props.friction ? '': format(constants.FRICTION_ERROR_TEXT, [props.friction]));
    }

    function onModalCancel() {
        setFrictionInput('');
        setErrorText('');
        props.onCancel ? props.onCancel() : props.onDismiss();
    }
    const frictionField = (
        <FormField errorText={errorText}>
            <Box>{constants.FRICTION_HINT_TEXT_PART_1}<em>{props.friction}</em>{constants.FRICTION_HINT_TEXT_PART_2}</Box>
            <Input value={frictionInput} placeholder={props.friction} onChange={onFrictionChange}></Input>
        </FormField>
    );
    return (
        <Modal
            visible={props.visible}
            onDismiss={props.onDismiss}
            closeAriaLabel='Close modal'
            size={ props.size ?? 'medium' }
            header={props.header}
            footer={
                <Box float='right'>
                    <SpaceBetween direction='horizontal' size='xs'>
                        <Button variant='link'
                            loading={props.confirmLoading}
                            onClick={onModalCancel}>
                            {constants.CANCEL_BUTTON_TEXT}
                        </Button>
                        {props.secondaryButton ? (
                            <Button
                                loading={props.confirmLoading}
                                onClick={props.onSecondaryConfirm}
                                disabled={props.friction && props.friction !== frictionInput || props.confirmDisabled}>
                                {props.secondaryButton}
                            </Button>
                        ) : null }
                        <Button
                            data-testid='submitBtn'
                            variant='primary'
                            loading={props.confirmLoading}
                            onClick={props.onConfirm}
                            disabled={props.friction && props.friction !== frictionInput || props.confirmDisabled}>
                            {props.confirmButton || constants.CONFIRM_BUTTON_TEXT}
                        </Button>
                    </SpaceBetween>
                </Box>
            }>
            {props.warning ? (<Alert dismissible={false} type='warning'>{props.warning}</Alert>) : null}
            {props.children}
            {props.friction ? frictionField : null}
        </Modal>
    );
};

export default ConfirmationModal;
